<div class="masive-charge">
  <form #charge="ngForm" autocomplete="off">
    <div class="masive-close alt-row-between">
      <mat-icon class="close-btn pointer" svgIcon="crossMenu" (click)="closeModal()"></mat-icon>
      <p class="  alt-inter-bold alt-size-20">{{"ORGANIZATION.masive" | translate}}</p>
    </div>

    <div class="text alt-row-between">
      <p class="alt-size-16">{{"ORGANIZATION.masive-info" | translate}}</p>
      <button class="charge-button pointer" (click)="donwloadCVS()">{{"ORGANIZATION.download"| translate | uppercase
        }}</button>
    </div>

    <div>

      <div *ngIf="archivos == ''" class="file-upload alt-column-justify-center">
        <input name="file" required ngModel (change)="something($event)" class="file-attached pointer" type="file">
        <p class="text-add alt-inter-semibold alt-size-14">{{"ORGANIZATION.text-instructions" | translate }}</p>
        <p class="text-upload alt-inter-semibold alt-size-14 alt-color-bran1">{{"ORGANIZATION.upload-file" | translate |
          uppercase}}</p>
      </div>

      <div *ngIf="archivos != ''" class="file-upload alt-column-justify-center"
        [class.succesFile]="status == 'success'">

        <div *ngIf="isLoaded === false">
          <div class="image-container">
            <mat-icon class="file-error" svgIcon="file"></mat-icon>
            <p class="file-nema-error alt-inter-medium alt-color-grayscale1 alt-size-16">{{fileName}}</p>
          </div>
        </div>

        <div *ngIf="isLoaded === true">
          <div *ngIf="status == 'init'">
            <div align="center" class="loading-charge">
              <ng-lottie width="200px" height="100px" [options]="options"></ng-lottie>
            </div>

            <p class="process-file alt-inter-medium alt-size-22 alt-color-grayscale1">{{"MASIVECHARGE.processFile" |
              translate}}</p>
            <p class="process-info alt-size-14 alt-color-grayscale1">{{"MASIVECHARGE.isProcesing" | translate}}</p>
          </div>


          <div *ngIf="status == 'success'">
            <div class="image-container">
              <mat-icon class="file-doc" svgIcon="file"></mat-icon>
            </div>
            <p class="text-uploaded alt-inter-semibold alt-size-20">{{"MASIVECHARGE.processDone" | translate}}</p>
            <p class="files-error-text alt-size-16 alt-inter-normal" *ngFor="let text of textFilesErrors">{{text}} </p>
          </div>
          <div *ngIf="status == 'error'">
            <div class="image-container">
              <mat-icon class="file-error" svgIcon="file"></mat-icon>
              <p class="file-nema-error alt-inter-medium alt-color-grayscale1 alt-size-16">{{fileName}}</p>
            </div>
          </div>
        </div>

      </div>
    </div>

    <div *ngIf="status == 'error'">
      <div class="file-empty-text">
        <p class="text-upload-change alt-inter-semibold alt-size-14 alt-color-system">{{"MASIVECHARGE.emptyFile" |
          translate}}</p>

        <div class="btn-area-continue alt-row-align-center">

          <p class="re-charge-file pointer alt-inter-medium alt-color-bran1 alt-size-14" (click)="reCharge()">
            {{"MASIVECHARGE.reLoad" | translate}}</p>
        </div>
      </div>

    </div>

    <div *ngIf="status == 'success'">

      <p class="continue-advertisig alt-inter-medium alt-size-16 alt-color-grayscale1">{{"MASIVECHARGE.continue" |
        translate}}</p>

      <p *ngIf="errorsInRegisters > 0 || duplicatesInRegisters > 0"
        class="continue-advertisig alt-inter-medium alt-size-16 alt-color-system">
        {{"MASIVECHARGE.advertisingError" | translate}}</p>

      <div class="btn-area-continue alt-row-align-center" [class.allRowsErros]="fileError">

        <p class="re-charge-file pointer alt-inter-medium alt-color-bran1 alt-size-14" [class.allRowsErros]="fileError"
          (click)="reCharge()">
          {{"MASIVECHARGE.reLoad" | translate}}</p>

        <button *ngIf="!fileError" type="button" class="btn-continue create-button pointer"
          (click)="sendFileToServer()">
          <p class="title-continue alt-inter-semibold alt-color-grayscale6 alt-size-14">{{'Sí, continuar'| uppercase }}
          </p>
        </button>
      </div>
    </div>

    <div class="extension-file-error-container" *ngIf="archivos != '' && isLoaded === false">

      <p class="extension-file-error alt-inter-semibold alt-size-14 alt-color-system">{{"MASIVECHARGE.notFileExtension"
        |
        translate }}</p>

      <div class="btn-area-continue alt-row-align-center">
        <p class="re-charge-file pointer alt-inter-medium alt-color-bran1 alt-size-14" (click)="reCharge()">
          {{"MASIVECHARGE.reLoad" | translate}}</p>
      </div>

    </div>

  </form>
</div>
